import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import qs from 'qs'
import camelCaseKeys from './lib/functions/camelCaseKeys'
import ucFirstKeys from './lib/functions/ucFirstKeys'
import 'flag-icon-css/css/flag-icon.min.css'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueMask from 'v-mask'
import money from 'v-money'
Vue.use(money)
Vue.use(VueMask)

Vue.component('FontAwesomeIcon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.prototype.$call = (call = {}) => {
  call = Object.assign(
    {
      env: 'beta',
      loading: false,
      refreshing: false,
      token: window.localStorage.token,
      lastCall: 0,
      method: 'GET',
      endPoint: '',
      request: {
        data: {}
      },
      response: {
        status: '',
        data: []
      }
    },
    call
  )
  return call
}

Vue.prototype.$api = async (call = {}) => {
  let api

  call.loading = true

  let url
  if (call.url) {
    url = call.url
  } else {
    url = `https://live-api.hectare.farm/${call.endPoint}`
  }

  let obj = {
    method: call.method,
    url: url,
    timeout: call.timeout | 15000,
    params: {},
    data: {},
    paramsSerializer: p => {
      return qs.stringify(p, { arrayFormat: 'brackets' })
    },
    headers: {
      Authorization: `Bearer ${call.token}`,
      platform: 'sellmylivestock',
      listingref: 'CE903691-6CC2-4A9A-81B9-A8BCD3904F63',
      accountref: 'A5DC1783-4F28-4703-AEA5-801AEA69C395',
      userref: 'A3B4CDB3-43A9-454C-8FB1-DFAB9F8242BF'
    }
  }

  if (call.request) {
    if (call.request.headers) {
      obj.headers = Object.assign(obj.headers, call.request.headers)
    }
  }

  if (obj.method === 'GET') {
    obj.params = call.request.data
  } else {
    obj.data = call.request.data
  }

  if (call.endPoint) {
    if (obj.method === 'GET') {
      obj.params = ucFirstKeys(obj.params)
    } else {
      obj.data = ucFirstKeys(obj.data)
    }

    obj.params = {
      HID: 'sellmylivestock',
      Token: call.token,
      ...obj.params
    }
  }

  try {
    api = await axios(obj)
    call.response = camelCaseKeys(api.data)
  } catch (e) {
    console.log(e)
  }

  call.loading = false

  return
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
